import { UserDetailsDto, UserPublicDto } from '../services/User/userService.dto';

export const extractUserName = (user: UserPublicDto | UserDetailsDto) => {
  if (!user) {
    return '';
  }
  return user.lastName ? `${user.firstName} ${user.lastName}` : user.firstName;
};
